import { createAction, createAsyncAction } from 'typesafe-actions';
import { SelectedPhoto, UploadPhotoToken } from '../types';

export const PROCESS_SELECTED_PHOTOS = createAction('reviews/UPLOAD_PHOTOS/processSelected')<File[]>();
export const REMOVE_SELECTED_PHOTO = createAction(
  'reviews/UPLOAD_PHOTOS/removeSelectedPhoto',
)<UploadPhotoToken>();
export const PERFORM_UPLOAD_PHOTO = createAsyncAction(
  'reviews/UPLOAD_PHOTOS/performRequest',
  'reviews/UPLOAD_PHOTOS/performSuccess',
  'reviews/UPLOAD_PHOTOS/performFailure',
  'reviews/UPLOAD_PHOTOS/performCancel',
)<UploadPhotoRequest, UploadPhotoSuccess, UploadPhotoError, UploadPhotoToken>();

export const PERFORM_UPLOAD_RETRY = createAction('reviews/UPLOAD_PHOTOS/performRetry')<UploadPhotoToken>();
export const STOP_UPLOAD = createAction('reviews/UPLOAD_PHOTOS/stopUpload')<UploadPhotoToken>();

type UploadPhotoRequest = {
  file: File;
  uploadToken: UploadPhotoToken;
};

type UploadPhotoSuccess = {
  uploadToken: UploadPhotoToken;
  photoId: string;
};

export type UploadPhotoCache = {
  file: File;
  uploadToken: UploadPhotoToken;
};

type PutUploadPhotoPayload = {
  uploadState: SelectedPhoto;
  file: File;
};
export const PUT_UPLOAD_PHOTO_RECORD = createAction(
  'reviews/UPLOAD_PHOTO/putStateRecord',
)<PutUploadPhotoPayload>();

export class UploadPhotoError extends Error {
  uploadToken: UploadPhotoToken;

  constructor(uploadToken: UploadPhotoToken, message?: string) {
    super(message);
    this.uploadToken = uploadToken;
  }
}
